export const hasVsDeveloperRole = (roles: readonly string[] | undefined): boolean =>
  roles?.includes('ROLE_VS_DEV') ?? false;
